import React from 'react';
import { useSelector } from 'react-redux';

import style from './style.css';

const AlertsResponseRateBox = () => {
    const backgroundColor = '#d9544d';

    const youthList = useSelector(state => state.app.careCoordinator.youthList);
    const selectedYouth = useSelector(state => state.app.dashboard.selectedYouth);

    const relevantYouth = selectedYouth ? [selectedYouth] : youthList;

    const criticalFlags = relevantYouth.flatMap(youth => (youth.flags || []).filter(flag => flag.critical));

    const getDaysFlagHasBeenFlagged = flag => {
        // expired flags count for a max of 12 days
        if (flag.unflaggedReason === 'expired') {
            return 12;
        }

        if (flag.status === 'flagged') {
            return (Date.now() - new Date(flag.date)) / (1000 * 60 * 60 * 24);
        }

        const latestUnflaggedEntry =
            flag.log &&
            [...flag.log]
                .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
                .find(entry => entry.status === 'unflagged');
        if (latestUnflaggedEntry) {
            return (new Date(latestUnflaggedEntry.updatedAt) - new Date(flag.date)) / (1000 * 60 * 60 * 24);
        }
        return (Date.now() - new Date(flag.date)) / (1000 * 60 * 60 * 24);
    };

    const resolvedCount = criticalFlags.filter(flag => flag.status === 'unflagged').length;
    const totalDays = criticalFlags.reduce((sum, flag) => sum + getDaysFlagHasBeenFlagged(flag), 0);
    const avgDays = criticalFlags.length === 0 ? '—' : Math.round(totalDays / criticalFlags.length) + ' days';

    return (
        <div className={style.response_rate_box} style={{ backgroundColor }}>
            <div className={style.response_rate_role}>Critical Alerts</div>
            <div className={style.dividing_line} />
            <div className={style.response_rate_stats} style={{ justifyContent: 'center' }}>
                <div className={style.response_rate_stat}>
                    <div className={style.response_rate_stat_label}>Avg Response Time</div>
                    <div className={style.response_rate_percentage}>{avgDays}</div>
                    <div className={style.response_rate_count}>
                        {resolvedCount}/{criticalFlags.length} resolved
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AlertsResponseRateBox;
